import { createSelector } from 'reselect'

import { localize } from 'helpers/translator'

import answerStatus from 'helpers/enums/answerStatus'

const game_validation_selector = createSelector(
	[ state => state.game ],
	game => {

		let valid = true
		game.activities.every(question => {
			if (question.text !== '' || (question.icon && question.icon.id !== 0)) {
				let correctAnswers = 0
				question.answers.every(answer => {
					if (answer.correct) {
						correctAnswers++
					}
					if (answer.status !== answerStatus.EMPTY) {
						return true
					} else {
						valid = false
						return false
					}
				})
				if (correctAnswers === 0) {
					valid = false
					return false
				}
				return true
			} else {
				valid = false
				return false
			}
		})

		return {
			valid,
			message: valid?null:localize('quiz_complete_fields'),
		}

	}
)

export default game_validation_selector
